// extracted by mini-css-extract-plugin
export default {"pageHolder":"ChoosePanel_pageHolder__ju8pO","CardHolder":"ChoosePanel_CardHolder__qtNtT","signOutBtn":"ChoosePanel_signOutBtn__9-qkm"};